import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaRobot } from "react-icons/fa";
import { generateAiDescriptionAPI } from "../../../utils/requests/projects";
import { fetchSingleProjectSuccess } from "../../../store/actions/projects/projects.action";
import { toastError, toastSuccess } from "../../../utils/helpers/helper";

const GenerateAiDescriptionButton = ({ className = "" }) => {
  const [aiLoading, setAiLoading] = useState(false);
  const dispatch = useDispatch();
  const { singleProject } = useSelector((state) => state.projects);

  const urlSlug = singleProject?.url_slug;
  const aiDescription = singleProject?.ai_description;

  const handleGenerateAiDescription = async () => {
    if (!urlSlug || aiLoading) return;
    setAiLoading(true);
    try {
      const response = await generateAiDescriptionAPI(urlSlug);
      dispatch(
        fetchSingleProjectSuccess({
          ...singleProject,
          ai_description: response.ai_description,
          ai_description_fetched_at: response.ai_description_fetched_at,
          can_generate_ai_description: response.can_generate_ai_description,
          last_modified_date: response.last_modified_date ?? singleProject.last_modified_date,
          last_modified_date_simple: response.last_modified_date_simple ?? singleProject.last_modified_date_simple,
        })
      );
      toastSuccess("AI description generated");
    } catch (error) {
      const message =
        error?.data?.message ||
        error?.data?.detail ||
        "Unable to generate AI description";
      if (error?.data?.ai_description) {
        dispatch(
          fetchSingleProjectSuccess({
            ...singleProject,
            ai_description: error.data.ai_description,
            ai_description_fetched_at: error.data.ai_description_fetched_at,
            can_generate_ai_description:
              error.data.can_generate_ai_description ?? false,
          })
        );
      }
      toastError(message);
    } finally {
      setAiLoading(false);
    }
  };

  if (!urlSlug) return null;

  return (
    <button
      type="button"
      className={`btn btn-outline-primary d-inline-flex align-items-center ${className}`}
      onClick={handleGenerateAiDescription}
      disabled={aiLoading}
      title="Generate a detailed description with AI using this opportunity's basic info"
    >
      {aiLoading ? (
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        />
      ) : (
        <FaRobot className="me-2" size={14} />
      )}
      {aiLoading
        ? "Generating..."
        : aiDescription
        ? "Regenerate AI Description"
        : "Generate AI Description"}
    </button>
  );
};

export default GenerateAiDescriptionButton;
